import { trackEvent } from '@kcd/event-tracker';

import { useCurrentUserPlusMembership } from '~/domains/auth/queries';
import { usePushWithQuery } from '~/hooks/url';

export function CouponDiscountBar() {
  const { data } = useCurrentUserPlusMembership();

  const nextPush = usePushWithQuery();
  const {
    totalCouponDiscountPrice,
    usedCouponDiscountPrice,
    unusedCouponDiscountPrice,
  } = data || {};

  const onClick = () => {
    trackEvent('clicked banner in 마켓/마이페이지', {
      name: '멤버십혜택',
    });
    void nextPush('/offers/popular-showcase');
  };

  if (!data) return null;

  return (
    <div>
      <div className="mb-[3px] rounded-lg bg-secondary-heavy py-8 text-center text-gray-000 typo-caption100-regular">
        플러스 멤버십 쿠폰 혜택으로 총{' '}
        {unusedCouponDiscountPrice?.toLocaleString()}원 할인 가능해요
      </div>
      <button
        className="block w-full rounded-12 bg-card-02 px-16 pb-12 pt-8"
        type="button"
        onClick={onClick}
      >
        <div className="flex items-center">
          <div className="flex flex-1 justify-between">
            <div className="text-description typo-caption100-regular">
              사용 혜택
            </div>
            <div className="text-normal typo-caption100-semibold">
              {usedCouponDiscountPrice?.toLocaleString()}원
            </div>
          </div>
          <div className="mx-12 h-16 w-1 bg-gray-300" />
          <div className="flex flex-1 justify-between">
            <div className="relative">
              <div className="relative flex justify-center">
                <div className="absolute top-[-11px] size-0 border-8 border-solid border-x-transparent border-b-transparent border-t-gray-1200" />
              </div>
              <div className="text-bonuspackGreen-text typo-caption100-semibold">
                남은 혜택
              </div>
            </div>
            <div className="text-normal typo-caption100-semibold">
              {unusedCouponDiscountPrice?.toLocaleString()}원
            </div>
          </div>
        </div>
        <div className="mt-12 h-8 w-full rounded-[4px] bg-gray-300">
          <div
            className="h-full min-w-8 max-w-full rounded-[4px] bg-bonuspackGreen-background"
            style={{
              width: `calc(((100% - 8px) / ${totalCouponDiscountPrice || 0} * ${
                usedCouponDiscountPrice || 0
              }) + 8px)`,
            }}
          />
        </div>
        <div className="mt-4 text-center text-hint typo-footnote200-regular">
          보유 멤버십 혜택 총{' '}
          <strong>{totalCouponDiscountPrice?.toLocaleString()}원</strong>
        </div>
      </button>
    </div>
  );
}
